<template>
  <div id="contenedor-editar-anticipo">
    <v-form
      v-model="formularioValido"
      ref="editarContratoAnticipo">
      <v-card>
        <v-card-title class="secondary--text">
          Editar anticipo
          <v-spacer></v-spacer>
          <v-btn icon @click="cerrar">
            <v-icon class="secondary--text" large>highlight_off</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-row align="center">
            <custom-date-picker
              cols="12"
              v-model="contratoAnticipo.fecha"
              label="Fecha"
              :rules="[mixReglas.requerido]">
            </custom-date-picker>
            <custom-text-field
              cols="12"
              md="6"
              v-model.number="contratoImporte"
              label="Monto Contrato"
              es-dinero
              prefix="$"
              :rules="[mixReglas.requerido]">
            </custom-text-field>
            <custom-text-field
              cols="12"
              md="6"
              v-model.number="contratoAnticipo.porcentaje"
              suffix="%"
              label="Porcentaje"
              type="number"
              :rules="[mixReglas.requerido]"
              @keyup="calcularTotal">
            </custom-text-field>
            <template
              v-if="contrato.esObraFinanciada">
              <v-col
                cols="12">
                <v-divider></v-divider>
              </v-col>
              <custom-text-field
                cols="12"
                md="6"
                v-model.number="contratoAnticipo.importeInicioTrabajos"
                label="Costo inicio trabajos"
                es-dinero
                prefix="$"
                :rules="[mixReglas.requerido]"
                readonly
                disabled>
              </custom-text-field>
              <custom-text-field
                cols="12"
                md="6"
                v-model.number="contratoAnticipo.importeCostoFinanciamiento"
                label="Costo Financiamiento"
                es-dinero
                prefix="$"
                :rules="[mixReglas.requerido]"
                @keyup="calcularTotal">
              </custom-text-field>
              <v-col
                cols="12">
                <v-divider></v-divider>
              </v-col>
            </template>
            <custom-text-field
              cols="12"
              class="pb-1"
              v-model="contratoAnticipo.importe"
              label="Importe"
              es-dinero
              prefix="$"
              :rules="[mixReglas.requerido]"
              readonly
              disabled>
            </custom-text-field>
            <custom-text-field
              cols="12"
              md="4"
              v-model="contratoPorcentajeIva"
              label="% IVA"
              suffix="%"
              type="number"
              readonly
              disabled>
            </custom-text-field>
            <custom-text-field
              cols="12"
              md="8"
              v-model="contratoAnticipo.iva"
              label="Importe IVA"
              es-dinero
              prefix="$"
              :rules="[mixReglas.requerido]"
              readonly
              disabled>
            </custom-text-field>
            <custom-text-field
              cols="12"
              v-model="contratoAnticipo.total"
              label="Total"
              es-dinero
              prefix="$"
              :rules="[mixReglas.requerido]"
              readonly
              disabled>
            </custom-text-field>
          </v-row>
        </v-card-text>
        <v-divider class="bkground" />
        <v-card-actions>
          <v-spacer></v-spacer>
          <custom-button
            @click="cerrar"
            tipo="formCancelar"
            label="Cancelar"
            class="mr-3">
          </custom-button>
          <custom-button
            @click="mixActualizarAnticipo"
            :disabled="!formularioValido || enviandoFormulario"
            :loading="enviandoFormulario"
            tipo="formAceptar"
            label="Actualizar">
          </custom-button>
        </v-card-actions>
      </v-card>
    </v-form>
  </div>
</template>

<script>
import mixAnticipoContrato from './mixAnticipoContrato';
import CustomTextField from '@/components/inputs/TextField.vue';
import CustomDatePicker from '@/components/inputs/DatePicker.vue';
import CustomButton from '@/components/buttons/Button.vue';

export default {
  name: 'EditarCotratoAnticipo',
  mixins: [mixAnticipoContrato],
  components: {
    CustomTextField,
    CustomDatePicker,
    CustomButton,
  },
  props: {
    contrato: Object,
    contratoAnticipoEditar: Object,
  },
  data() {
    return {
      contratistaSelected: null,
      formularioValido: false,
      enviandoFormulario: false,
      contratoImporte: this.contrato.importe,
      contratoPorcentajeIva: this.contrato.porcentajeIva,
      contratoAnticipo: {
        // idObra: ID,
        fecha: this.contratoAnticipoEditar.fecha,
        porcentaje: this.contratoAnticipoEditar.porcentaje,
        importeInicioTrabajos: this.contratoAnticipoEditar.importeInicioTrabajos,
        importeCostoFinanciamiento: this.contratoAnticipoEditar.importeCostoFinanciamiento,
        porcentajeCostoFinanciamiento: this.contratoAnticipoEditar.porcentajeCostoFinanciamiento,
        importe: this.contratoAnticipoEditar.importe,
        porcentajeIva: this.contratoAnticipoEditar.porcentajeIva,
        iva: this.contratoAnticipoEditar.iva,
        total: this.contratoAnticipoEditar.total,
      },
    };
  },
  methods: {
    limpiarFormulario() {
      this.$refs.editarContratoAnticipo.reset();
    },
    cerrar() {
      this.$emit('cerrar');
    },
  },
};
</script>

<style lang="scss">

</style>
